import React from 'react'
import { connect } from 'react-redux'
import Loader from '../../loaders'
import { strings } from '../../../localization/strings'
import TextField from '@material-ui/core/TextField/TextField'
import FormLabel from '@material-ui/core/FormLabel/FormLabel'
import Radio from '@material-ui/core/Radio/Radio'
import Button from '@material-ui/core/Button/Button'
import {
    getObjectKey,
    orderTypes,
    platforms,
    shippingMethods,
} from '../../../server/shared'
import { getCountrySubdivisionsAction } from '../../../actions/appActions'
import { getShippingRates, createNewOrder } from '../../../helpers/restHelpers'
import { PhoneNumberFormat, ReplaceQuotes } from '../../../utils/formaters'
import Typography from '@material-ui/core/Typography/Typography'
import { Grid, IconButton } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import {
    getPlaftormId,
    getShowOrderNewExplanation,
    setShowOrderNewExplanation,
} from '../../../helpers/dbHelpers'
import LockerSelectorInMap from '../../components/lockerSelectorInMap'
import ShipToAddressForm from '../../components/shipToAddressForm'
import { mailRegExp, notAlowedCharactersRegExp } from '../../../utils/regex'

const style = {
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
    page: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 500,
        margin: 'auto',
        padding: '20px 10px',
    },
    field: { marginTop: 15, flexGrow: 1 },
    option: { marginTop: 15, marginLeft: 25 },
}

const formatReq = (string) => (
    <div>
        {string}
        <span style={{ color: 'red' }}> *</span>
    </div>
)
const reload = () => window.location.reload(true)

class Component extends React.Component {
    state = {
        loading: true,
        reference: new Date().getTime(),
        shippingMethodList: null,
        errors: {},
        helperText: {},
        alias: '',
        mail: '',
        phoneNumber: '',
        postalCode: '',
        warehouse: null,
        toAddressErrors: {},
        toAddressData: {
            name: null,
            province: null,
            city: null,
            locality: null,
            streetAddress: null,
            streetNumber: null,
            floor: null,
            apartment: null,
        },
    }

    componentDidMount() {
        this.loadProvinceList()
    }

    loadProvinceList = () => {
        getCountrySubdivisionsAction(1)
            .then((x) =>
                x.length
                    ? this.setState({ provinceList: x, loading: false })
                    : window.showDialog({}, reload)
            )
            .catch((x) => window.showDialog(x, reload))
    }

    selectShippingMethodListOption = (method, index) => {
        this.setState({
            shippingMethodListOptionSelected: index,
            lockerId: null,
            shippingMethodId: method.shippingMethodId,
        })
    }

    submitCreateValidate = () => {
        let errors = {}
        let helperText = {}
        let { alias, mail, postalCode, shippingMethodId } = this.state
        let fieldsToValidate = {alias, mail, postalCode}
        if (!mail || !mailRegExp.test(mail)) errors.mail = true
        if (!alias) errors.alias = true
        if (!postalCode) errors.postalCode = true
        if (!shippingMethodId) errors.shippingMethodId = true

        // Caracteres especiales
        // for (let field in fieldsToValidate) {
        //     if (notAlowedCharactersRegExp.test(fieldsToValidate[field])) {
        //         errors[field] = true;
        //         helperText[field] = strings.notAllowedCharacters
        //     }
        // }

        if (shippingMethodId === shippingMethods.standard) {
            let { lockerId } = this.state
            if (!lockerId) errors.shippingMethodId = true
        }

        if (shippingMethodId === shippingMethods.shipToAddress) {
            const { toAddressData } = this.state
            let toAddressErrors = {}
            if (!toAddressData.name) toAddressErrors.name = true
            if (!toAddressData.province) toAddressErrors.province = true
            if (!toAddressData.city) toAddressErrors.city = true
            if (!toAddressData.streetAddress)
                toAddressErrors.streetAddress = true
            if (!toAddressData.streetNumber) toAddressErrors.streetNumber = true

            // Caracteres especiales
            // for (let field in toAddressData) {
            //     if (notAlowedCharactersRegExp.test(toAddressData[field])) {
            //         toAddressErrors[field] = true;
            //         helperText[field] = strings.notAllowedCharacters 
            //     }
            // }
    
            this.setState({ toAddressErrors })
            if (Object.keys(toAddressErrors).length > 0)
                errors.toAddressErrors = true
        }

        this.setState({ errors: errors, helperText: helperText })
        if (Object.keys(errors).length > 0) return false
        return true
    }

    submitCreate = () => {
        if (!this.submitCreateValidate()) return

        let {
            reference,
            alias,
            mail,
            phoneNumber,
            shippingMethodId,
            postalCode,
        } = this.state
        let data = { reference, alias, mail, phoneNumber, shippingMethodId }

        if (shippingMethodId === shippingMethods.standard) {
            let { lockerId } = this.state
            data.lockerId = lockerId
        }

        if (shippingMethodId === shippingMethods.shipToAddress) {
            const { toAddressData } = this.state
            data.recipient = {
                name: toAddressData.name,
                phoneNumber: phoneNumber,
                address: {
                    streetName: toAddressData.streetAddress,
                    streetNumber: toAddressData.streetNumber,
                    floor: toAddressData.floor,
                    apartment: toAddressData.apartment,
                    countrySubdivision: toAddressData.province.name,
                    city: toAddressData.city,
                    locality: toAddressData.locality,
                    postalCode: postalCode,
                },
            }
        }

        this.setState({ loading: true })

        data.orderType = orderTypes.noPlatform

        ReplaceQuotes(data)

        createNewOrder(data)
            .then(() =>
                window.showDialog(
                    {
                        message: strings.orderNewSuccessfulCreationMessage,
                        title: ' ',
                    },
                    reload
                )
            )
            .catch((x) => window.showDialog(x, reload))
    }

    calculate = () => {
        const { postalCode } = this.state
        const ordeType = orderTypes.noPlatform
        this.setState({ loading: true })
        getShippingRates(postalCode, ordeType)
            .then((x) => this.setState({ shippingMethodList: x }))
            .catch((x) => window.showDialog(x))
            .finally(() => this.setState({ loading: false }))
    }

    renderStandardMethod = (lockerList, error) => {
        return (
            <LockerSelectorInMap
                list={lockerList}
                idSelected={this.state.lockerId}
                handleChange={(x) => this.setState({ lockerId: x })}
            />
        )
    }

    renderShipToAddressMethod = () => {
        return (
            <ShipToAddressForm
                errors={this.state.toAddressErrors}
                helperText={this.state.helperText}
                fields={this.state.toAddressData}
                provinceList={this.state.provinceList}
                handleChange={(key, value) =>
                    this.setState({
                        toAddressData: {
                            ...this.state.toAddressData,
                            [key]: value,
                        },
                        toAddressErrors: {
                            ...this.state.toAddressErrors,
                            [key]: false,
                        },
                    })
                }
            />
        )
    }

    getOrderNewDescriptionText = () => {
        let platformId = getPlaftormId()
        let orderNewDescription =
            strings.orderNewDescription[getObjectKey(platforms, platformId)]
        return orderNewDescription
            ? orderNewDescription
            : strings.orderNewDescription.noPlatform
    }

    showExplanationDialogs = () => {
        if (getShowOrderNewExplanation()) {
            setTimeout(() => {
                window.showDialog(
                    {
                        title: ' ',
                        message: this.getOrderNewDescriptionText(),
                    },
                    () => setShowOrderNewExplanation(false)
                )
            }, 0)
        }
    }

    getPostalCodePlaceholder = () => {
        try {
            let cp = this.props.appStore.warehouseInfo.address.postalCode
            if (!cp) new Error()
            return 'Ej. ' + cp
        } catch (e) {
            return strings.postalCodePlaceholder
        }
    }

    render() {
        if (this.state.loading) return <Loader />
        this.showExplanationDialogs()

        let {
            errors,
            helperText,
            shippingMethodListOptionSelected,
            shippingMethodList,
            alias,
            mail,
            phoneNumber,
            postalCode,
        } = this.state

        return (
            <div style={style.page}>
                <Grid item style={{ textAlign: 'center' }} xs={12}>
                    <Typography variant={'h6'}>
                        {strings.orderNewHeader}
                        <IconButton
                            onClick={() =>
                                window.showDialog({
                                    title: ' ',
                                    message: this.getOrderNewDescriptionText(),
                                })
                            }
                        >
                            <InfoIcon fontSize="small" />
                        </IconButton>
                    </Typography>
                </Grid>
                <TextField
                    label={formatReq(strings.orderNewAlias)}
                    placeholder={strings.orderNewAliasPlaceholder}
                    value={alias}
                    onChange={(x) =>
                        this.setState({
                            alias: x.target.value,
                            errors: { ...errors, alias: false },
                        })
                    }
                    error={errors.alias}
                    helperText={helperText.alias}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 19 }}
                    style={style.field}
                />

                <TextField
                    label={formatReq(strings.clientEmail)}
                    value={mail}
                    placeholder={strings.emailPlaceholder}
                    onChange={(x) =>
                        this.setState({
                            mail: x.target.value,
                            errors: { ...errors, mail: false },
                        })
                    }
                    error={errors.mail}
                    helperText={helperText.mail}
                    InputLabelProps={{ shrink: true }}
                    style={style.field}
                />

                <TextField
                    label={strings.clientPhoneNumber}
                    value={phoneNumber}
                    placeholder={strings.phoneNumberPlaceholder}
                    onChange={(x) =>
                        this.setState({
                            phoneNumber: x.target.value,
                            errors: { ...errors, phoneNumber: false },
                        })
                    }
                    error={errors.phoneNumber}
                    helperText={helperText.phoneNumber}
                    InputLabelProps={{ shrink: true }}
                    style={style.field}
                    InputProps={{ inputComponent: PhoneNumberFormat }}
                />

                <div style={style.row}>
                    <TextField
                        label={formatReq(strings.postalCode)}
                        value={postalCode}
                        placeholder={this.getPostalCodePlaceholder()}
                        onChange={(x) =>
                            this.setState({
                                postalCode: x.target.value,
                                shippingMethodList: null,
                                errors: { ...errors, postalCode: false },
                            })
                        }
                        error={errors.postalCode}
                        helperText={helperText.postalCode}
                        InputLabelProps={{ shrink: true }}
                        style={style.field}
                        InputProps={{ inputComponent: PhoneNumberFormat }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.calculate}
                        disabled={!postalCode}
                    >
                        {strings.orderNewSearchButton}
                    </Button>
                </div>

                <div style={style.field} />
                <div style={style.field} />

                {!shippingMethodList ? null : !shippingMethodList.length ? (
                    <Typography variant="h6" color="secondary">
                        {strings.orderNewShippingMethodsEmpty}
                    </Typography>
                ) : (
                    <>
                        <FormLabel
                            component="legend"
                            error={errors.shippingMethodId}
                        >
                            {strings.orderNewShippingMethodsTitle}
                        </FormLabel>
                        {shippingMethodList.map((method, index) => (
                            <div key={index}>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Radio
                                        checked={
                                            shippingMethodListOptionSelected ===
                                            index
                                        }
                                        inputProps={{ 'aria-label': 'A' }}
                                        onChange={() =>
                                            this.selectShippingMethodListOption(
                                                method,
                                                index
                                            )
                                        }
                                    />
                                    <div style={{ flexGrow: 1 }}>
                                        {
                                            strings.shippingMethods[
                                                getObjectKey(
                                                    shippingMethods,
                                                    method.shippingMethodId
                                                )
                                            ]
                                        }
                                    </div>
                                    <div>${method.cost}</div>
                                </div>

                                {method.shippingMethodId === 1 &&
                                shippingMethodListOptionSelected === index
                                    ? this.renderStandardMethod(method.options)
                                    : null}
                                {method.shippingMethodId === 3 &&
                                shippingMethodListOptionSelected === index
                                    ? this.renderShipToAddressMethod()
                                    : null}
                            </div>
                        ))}
                    </>
                )}

                <Button
                    style={{ margin: 'auto', marginTop: 30 }}
                    variant="contained"
                    color="primary"
                    onClick={this.submitCreate}
                    disabled={
                        !shippingMethodList ||
                        !shippingMethodList.length ||
                        !this.state.shippingMethodId ||
                        (this.state.shippingMethodId === 1 &&
                            !this.state.lockerId)
                    }
                >
                    {strings.orderNewCreateButton}
                </Button>
            </div>
        )
    }
}

const mapDispatchToProps = {}
const mapStateToProps = (store) => ({ appStore: store.app })
export default connect(mapStateToProps, mapDispatchToProps)(Component)
